var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { KeycloakService } from '../../services/keycloak.service';
import { ActuacionService } from '../../services/actuacion.service';
import { Pager } from '../../common/pager/pager.component';
import { CommonService } from '../../services/common.service';
var ActuacionPopupComponent = (function () {
    function ActuacionPopupComponent(_service, _comService, sanitizer) {
        this._service = _service;
        this._comService = _comService;
        this.sanitizer = sanitizer;
        this.visible = false;
        //public video:boolean = false;
        this.visiblePreview = false;
        this.images = [];
        this.pageSize = 5;
        this.pageNumber = 0;
        this.showWarn = false;
    }
    ActuacionPopupComponent.prototype.loadAct = function (id) {
        var _this = this;
        //console.log("OPEN ACT POPUP " + id);
        this.aviso = this._comService.getConfiguracion("AVISOACT");
        this.id = id;
        this._service.findActuacion(this.id, KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.actuacion = response;
            //console.log(this.actuacion);
            _this.visible = true;
            if (!_this.video) {
                _this.getTextoAct();
            }
            else {
                //console.log("cargando video");                
                _this.getVideoAct();
            }
        });
        //this.getTextoAct();
        //console.log("act pages: " + this.pageNumber);
    };
    ActuacionPopupComponent.prototype.getVideoAct = function () {
        this.urlVideo = this._service.findVideoActPath(this.ticket);
        //console.log("video file " + this.urlVideo.substring(this.urlVideo.lastIndexOf("/")));
        //this.videoplayer.nativeElement.play();
    };
    ActuacionPopupComponent.prototype.getTextoAct = function (page) {
        var _this = this;
        if (page === void 0) { page = 0; }
        this._service.findTextoAct(this.id, page, this.pageSize).subscribe(function (response) {
            _this.textoAct = response;
            var i = 0;
            _this.images = [];
            var that = _this;
            response.texto.split(",").forEach(function (image) {
                that.images[i++] = _this.sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64,"
                    + image);
            });
            _this.showWarn = response.isJpx;
            //console.log("pages received (" + response.isJpx + ")" + this.images.length);
            _this.pageNumber = _this.textoAct.pages;
            try {
                _this.scrollable.nativeElement.scrollTop = 0;
            }
            catch (error) {
            }
            _this.visiblePreview = true;
            if (_this.pager) {
                _this.pager.setLock(false);
            }
        });
    };
    ActuacionPopupComponent.prototype.gotoPage = function (page) {
        //console.log("goto " + page);
        this.pager.setLock(true);
        this.getTextoAct(page);
    };
    ActuacionPopupComponent.prototype.downloadData = function () {
        var _this = this;
        if (!this.video) {
            //console.log("INCRUSTADA " + this.actuacion.incrustada);
            this._comService.emitBlocking(true);
            if (this.actuacion.incrustada) {
                this._service.getPdfAct(this.id).subscribe(function (response) {
                    //console.log("blob: "+response.size);
                    _this._comService.emitBlocking(false);
                    saveAs(response, "actuacion.pdf");
                }, function (error) {
                    _this._comService.emitBlocking(false);
                });
            }
            else {
                this._service.getPdfPki(this.id).subscribe(function (response) {
                    //console.log("blob: "+response.size);
                    _this._comService.emitBlocking(false);
                    saveAs(response, "actuacion.zip");
                }, function (error) {
                    _this._comService.emitBlocking(false);
                });
            }
            // }else{
            //     this._service.getZipVideo(this.id).subscribe(response => {
            //         console.log("blob: "+response.size);
            //         this._comService.emitBlocking(false);
            //         saveAs(response, "video.zip");
            //     }, (error: Response) => {
            //         this._comService.emitBlocking(false);
            //     });
        }
    };
    ActuacionPopupComponent.prototype.finalize = function () {
        this.visible = false;
        this.visiblePreview = false;
        this.actuacion = null;
        this.images = [];
        this.textoAct = null;
        if (this.pager) {
            this.pager.pcount = 0;
        }
    };
    return ActuacionPopupComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", String)
], ActuacionPopupComponent.prototype, "id", void 0);
__decorate([
    ViewChild(Pager),
    __metadata("design:type", Pager)
], ActuacionPopupComponent.prototype, "pager", void 0);
__decorate([
    ViewChild('scrollable'),
    __metadata("design:type", ElementRef)
], ActuacionPopupComponent.prototype, "scrollable", void 0);
__decorate([
    ViewChild('videoPlayer'),
    __metadata("design:type", ElementRef)
], ActuacionPopupComponent.prototype, "videoplayer", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ActuacionPopupComponent.prototype, "expediente", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ActuacionPopupComponent.prototype, "caratula", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ActuacionPopupComponent.prototype, "organismo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ActuacionPopupComponent.prototype, "video", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ActuacionPopupComponent.prototype, "ticket", void 0);
ActuacionPopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'actuacion-popup',
        templateUrl: 'actuacion-popup.component.html'
    }),
    __metadata("design:paramtypes", [ActuacionService, CommonService, DomSanitizer])
], ActuacionPopupComponent);
export { ActuacionPopupComponent };
//# sourceMappingURL=actuacion-popup.component.js.map